/**
 * Interface représentant une agence immobilière
 */
export interface Agency {
  id: string;
  name: string;
  address: string;
  logo_url?: string | null;
  created_at: string | Date;
}

/**
 * Interface pour les données nécessaires à la création d'une agence
 */
export type AgencyCreateInput = Omit<Agency, 'id' | 'created_at'>;

/**
 * Interface pour les données de mise à jour d'une agence
 */
export type AgencyUpdateInput = Partial<AgencyCreateInput>;

/**
 * Configuration par défaut pour l'upload de logo
 */
export const DEFAULT_LOGO_CONFIG = {
  maxSizeKB: 100,
  allowedFormats: ['image/jpeg', 'image/png', 'image/svg+xml'],
  maxWidth: 200,
  maxHeight: 100
};

/**
 * Vérifie si le format du fichier est valide pour un logo
 */
export const isValidLogoFormat = (mimeType: string): boolean => {
  return DEFAULT_LOGO_CONFIG.allowedFormats.includes(mimeType);
};

